document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('product-recommendations.hh-related-v2').forEach(function(root){
    const url=root.dataset.url;
    if(!url)return;

    function initialise(){
      initStepAutoplay(root);
    }

    if(root.querySelector('.hh-related-v2__card')){
      initialise();
      return;
    }

    fetch(url)
      .then(r=>r.text())
      .then(htmlText=>{
        const temp=document.createElement('div');
        temp.innerHTML=htmlText;
        const fresh=temp.querySelector('#'+root.id);
        if(fresh&&fresh.innerHTML.trim()){
          root.innerHTML=fresh.innerHTML;
          initialise();
        }
      })
      .catch(()=>{});
  });

  function initStepAutoplay(root){
    const rail=root.querySelector('[data-hh-related-rail]');
    if(!rail||rail.dataset.hhStepReady==='true')return;
    rail.dataset.hhStepReady='true';

    if(rail.dataset.autoplay!=='true')return;
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;

    const cards=[...rail.querySelectorAll('.hh-related-v2__card')];
    if(cards.length<2)return;

    const delay=Math.max(3000,parseInt(rail.dataset.delay||'5000',10));
    let index=0;
    let direction=1;
    let timer=null;
    let paused=false;

    function targetFor(i){
      return Math.round(cards[i].offsetLeft - cards[0].offsetLeft);
    }

    function maxReachableIndex(){
      const maxScroll=rail.scrollWidth-rail.clientWidth;
      let idx=0;
      cards.forEach(function(card,i){
        if(targetFor(i)<=maxScroll+2)idx=i;
      });
      return idx;
    }

    function moveTo(i){
      index=i;
      rail.scrollTo({left:targetFor(index),behavior:'smooth'});
    }

    function tick(){
      if(paused)return;
      const max=maxReachableIndex();
      if(max<1)return;

      if(direction>0){
        if(index>=max){
          direction=-1;
          moveTo(Math.max(0,index-1));
        }else{
          moveTo(index+1);
        }
      }else{
        if(index<=0){
          direction=1;
          moveTo(Math.min(max,index+1));
        }else{
          moveTo(index-1);
        }
      }
    }

    function start(){
      stop();
      timer=setInterval(tick,delay);
    }

    function stop(){
      if(timer){
        clearInterval(timer);
        timer=null;
      }
    }

    root.addEventListener('mouseenter',()=>{paused=true});
    root.addEventListener('mouseleave',()=>{paused=false;start()});
    root.addEventListener('focusin',()=>{paused=true});
    root.addEventListener('focusout',()=>{paused=false;start()});
    rail.addEventListener('touchstart',()=>{paused=true},{passive:true});
    rail.addEventListener('touchend',()=>{paused=false;start()},{passive:true});

    rail.addEventListener('scroll',function(){
      if(paused)return;
      const left=rail.scrollLeft;
      let nearest=0;
      let dist=Infinity;
      cards.forEach(function(card,i){
        const d=Math.abs(targetFor(i)-left);
        if(d<dist){dist=d;nearest=i}
      });
      index=nearest;
    },{passive:true});

    start();
  }
});